import request from '@/axios/request';

//编辑信息
export function updataUserInfo(data) {
  return request({
    url: '/api/user/modifyAccount',
    method: 'post',
    data: data
  })
}
//编辑信息
export function updataPassword(data) {
  return request({
    url: '/api/user/changePassword',
    method: 'post',
    data: data
  })
}


//编辑信息
export function validatePassword(data) {
  return request({
    url: '/api/user/validatePassword',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/userInfo.js